import { render, staticRenderFns } from "./bill-attributes.vue?vue&type=template&id=2ffd9751&scoped=true&"
import script from "./bill-attributes.vue?vue&type=script&lang=js&"
export * from "./bill-attributes.vue?vue&type=script&lang=js&"
import style0 from "./bill-attributes.vue?vue&type=style&index=0&id=2ffd9751&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffd9751",
  null
  
)

export default component.exports